import { render } from "./MIcon.vue?vue&type=template&id=2894e756&scoped=true"
import script from "./MIcon.vue?vue&type=script&lang=js"
export * from "./MIcon.vue?vue&type=script&lang=js"

import "./MIcon.vue?vue&type=style&index=0&id=2894e756&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2894e756"]])

export default __exports__